import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  .monitors {
    gap: 4px;
    padding: 0 0.3rem;
    background-color: #ffffff;
    border-radius: 5px;
  }

  .monitors-length {
    margin-top: 0.13rem;
    color: #007bff;
  }
`;

export const LinkButton = styled.button`
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  font-size: 0.95rem;
`;

export const LoadingMonitoreButton = styled.span`
  width: 25px;

  @media only screen and (max-width: 768px) {
    height: 15px;
  }
`;
